###############################################################################
##
##  Default street
##
##  The "default street" was designed to be a pretty "good" street as well
##  as a showcase of Streetmix features. It has changed over time, and can
##  continue to do so.
##
###############################################################################

width: 21.3
boundary:
  left:
    variant: narrow
    floors: 4
    elevation: 1
  right:
    variant: wide
    floors: 3
    elevation: 1
slices:
  - type: sidewalk
    variant:
      sidewalk-density: dense
    width: 1.8
    material: trottoir
  - type: sidewalk-tree
    variant:
      tree-type: big
    width: 0.6
    material: trottoir
  - type: sidewalk-lamp
    variant:
      lamp-orientation: right
      lamp-type: modern
    width: 0.6
    material: trottoir
  - type: bus-lane
    variant:
      direction: inbound
      bus-asphalt: shared
      bus-type: typical
    width: 3.6
  - type: drive-lane
    variant:
      direction: inbound
      car-type: car
    width: 2.7
  - type: divider
    variant:
      divider-type: bush
    width: 0.9
  - type: drive-lane
    variant:
      direction: outbound
      car-type: car
    width: 3
  - type: parking-lane
    variant:
      parking-lane-direction: outbound
      parking-lane-orientation: right
    width: 2.1
  - type: divider
    variant:
      divider-type: planter-box
    width: 1.2
    material: trottoir
  - type: bike-lane
    variant:
      bike-direction: outbound
      bike-asphalt: green
      elevation: road
    width: 1.8
    material: bike
  - type: sidewalk-lamp
    variant:
      lamp-orientation: left
      lamp-type: modern
    width: 0.6
    material: trottoir
  - type: sidewalk-tree
    variant:
      tree-type: big
    width: 0.6
    material: trottoir
  - type: sidewalk
    variant:
      sidewalk-density: normal
    width: 1.8
    material: trottoir
